/* eslint-disable no-console */
import nodeFetch from "node-fetch";

// The @nuxtjs/apollo plugin forwards all browser cookies to the GraphQL
// server during SSR. Large cookies (e.g. Cognito JWTs) exceed nginx's
// header size limit and cause 403s. Strip the cookie header server-side.
const ssrFetch = (url, options) => {
  const { cookie, ...headers } = options.headers || {};
  return nodeFetch(url, { ...options, headers, signal: undefined });
};

export default () => ({
  httpEndpoint: process.env.WP_GRAPHQL_SERVER,
  httpLinkOptions: {
    fetch: process.server ? ssrFetch : undefined,
  },
});
